export type SessionSearch = {
  session?: number;
};

/** Normalisiert den optionalen Session-Deep-Link aus der URL. */
export function parseSessionSearch(search: Record<string, unknown>): SessionSearch {
  const rawSession = search.session;
  const session = typeof rawSession === "number" ? rawSession : typeof rawSession === "string" ? Number(rawSession) : Number.NaN;
  return Number.isInteger(session) && session > 0 ? { session } : {};
}

type DeepLinkOpenDecision = {
  canWrite: boolean;
  sessionId?: number;
  suppressedSessionId: number | null;
  drawerOpen: boolean;
  editingId: number | null;
};

/** Verhindert unberechtigtes oder erneutes Öffnen eines Session-Drawers durch die URL. */
export function shouldOpenSessionDeepLink({ canWrite, sessionId, suppressedSessionId, drawerOpen, editingId }: DeepLinkOpenDecision) {
  return Boolean(canWrite && sessionId && suppressedSessionId !== sessionId && !(drawerOpen && editingId === sessionId));
}
